import React from "react";
import { Link } from "react-router";
import "./detailedOffers.scss";
import { Home, Ceiling, Spackling, Roller, Panels } from "../../../icons";

interface OfferDetail {
  id: string;
  badge: string;
  title: string;
  subtitle: string;
  description: string;
  features: string[];
  Icon: React.ComponentType;
}

const detailedOffersList: OfferDetail[] = [
  {
    id: "kompleksowe",
    badge: "Pakiet Główny",
    title: "Kompleksowe Wykończenia Wnętrz",
    subtitle: "Od stanu deweloperskiego po gotowe do zamieszkania",
    description:
      "Przejmujemy pełną odpowiedzialność za cały proces remontowo-wykończeniowy. Dbamy o harmonogram, doradztwo techniczne i bezstresowy przebieg prac według Twoich oczekiwań lub projektu architekta.",
    features: [
      "Wykończenia mieszkań deweloperskich, domów oraz lokali",
      "Koordynacja wszystkich branż i etapów realizacji",
    ],
    Icon: Home,
  },
  {
    id: "gk-sufity",
    badge: "Konstrukcje",
    title: "Zabudowy G-K i Sufity Podwieszane",
    subtitle: "Nowoczesne sufity LED, wnęki i ścianki działowe",
    description:
      "Projektujemy i montujemy solidne konstrukcje z płyt gipsowo-kartonowych. Pozwalają one na efektowne ukrycie instalacji, wydzielenie stref oraz stworzenie designerskiego oświetlenia.",
    features: [
      "Sufity podwieszane jedno i wielopoziomowe",
      "Zabudowy z wpustami LED, ukrytymi karniszami i oświetleniem liniowym",
      "Ścianki działowe o podwyższonej izolacji akustycznej",
      "Stabilne stelaże wzmacniane pod montaż szafek i ciężkich elementów",
    ],
    Icon: Ceiling,
  },
  {
    id: "szpachlowanie",
    badge: "Powierzchnie",
    title: "Gładzie Bezpyłowe i Szpachlowanie",
    subtitle: "Idealnie równe i gładkie ściany przygotowane pod malowanie",
    description:
      "Wykorzystujemy nowoczesne technologie aplikacji gładzi oraz bezpyłowe szlifowanie mechaniczne, zapewniając perfekcyjną gładź bez bałaganu w całym lokalu.",
    features: [
      "Nakładanie gładzi polimerowych i gipsowych",
      "Wzmacnianie narożników taśmami Tuff-Tape i profilami aluminiowymi",
      "Maskowanie pęknięć, łączeń płyt GK oraz ubytków w tynkach",
      "Gruntowanie powierzchni preparatami głęboko penetrującymi",
    ],
    Icon: Spackling,
  },
  {
    id: "malowanie",
    badge: "Kolor i Styl",
    title: "Malowanie Natryskowe i Tradycyjne",
    subtitle: "Perfekcyjna powłoka, jednolite krycie i trwałość",
    description:
      "Oferujemy hydrodynamiczne malowanie gwarantujące jednolitą strukturę.",
    features: [
      "Precyzyjne malowanie tradycyjne ścian akcentowych i detali",
      "Dokładne zabezpieczenie okien, drzwi, podłóg i grzejników",
      "Doradztwo w doborze farb lateksowych, ceramicznych i zmywalnych",
      "Aplikacja powłok dekoracyjnych i farb strukturalnych",
    ],
    Icon: Roller,
  },
  {
    id: "podlogi",
    badge: "Posadzki",
    title: "Montaż Paneli, Winyli i Parkietu",
    subtitle: "Trwałe, ciche i precyzyjnie spasowane podłogi",
    description:
      "Prawidłowy montaż podłogi to klucz do jej trwałości i braku skrzypienia. Zapewniamy dokładne przygotowanie podłoża, zachowanie dylatacji oraz precyzyjne docinanie listew.",
    features: [
      "Układanie paneli laminowanych, winylowych oraz drewnianych",
      "Wylewki samopoziomujące i niwelacja nierówności podłoża",
      "Montaż listew przypodłogowych MDF, aluminiowych i PCV pod kątem 45°",
      "Estetyczne łączenia bezprogowe między pomieszczeniami",
    ],
    Icon: Panels,
  },
];

const DetailedOffers: React.FC = () => {
  return (
    <section className="detailed-offers">
      <div className="detailed-offers__container">
        <header className="detailed-offers__header">
          <div className="detailed-offers__header-top">
            <span className="detailed-offers__header-line" />
            <span className="detailed-offers__eyebrow">PEŁNA OFERTA</span>
            <span className="detailed-offers__header-line" />
          </div>
          <h1 className="detailed-offers__title">
            Kompleksowe Usługi Wykończeniowe
          </h1>
          <p className="detailed-offers__description">
            Poznaj szczegółowy zakres naszych prac. Zapewniamy profesjonalne
            doradztwo, wysoką kulturę pracy oraz dbałość o każdy detal – od
            stanu deweloperskiego po gotowe, estetyczne wnętrze.
          </p>
        </header>

        <div className="detailed-offers__grid">
          {detailedOffersList.map((service) => (
            <article key={service.id} className="detailed-offers__card">
              <div className="detailed-offers__card-header">
                <div className="detailed-offers__icon-box">
                  <service.Icon />
                </div>
                <div className="detailed-offers__card-titles">
                  <span className="detailed-offers__badge">
                    {service.badge}
                  </span>
                  <h2 className="detailed-offers__card-title">
                    {service.title}
                  </h2>
                  <p className="detailed-offers__card-subtitle">
                    {service.subtitle}
                  </p>
                </div>
              </div>

              <p className="detailed-offers__card-description">
                {service.description}
              </p>

              <div className="detailed-offers__features-wrapper">
                <h3 className="detailed-offers__features-title">
                  Co wchodzi w zakres prac:
                </h3>
                <ul className="detailed-offers__features-list">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="detailed-offers__feature-item">
                      <span className="detailed-offers__check-icon">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DetailedOffers;
